module.exports = __webpack_public_path__ + "static/media/jack_diamond.d14344a1.png";